import { DynamicFormRepository } from '@/store/dynamic-form-state/dynamic-form.repository';
import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getDynamicFormDeleteObjectProps {
  store: DynamicFormRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getDynamicFormDeleteObject = ({ representation, action, toggleVisiblity, store }: getDynamicFormDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression de formulaire dynamique ${representation}`,
    description: 'Vous allez supprimer ce formulaire dynamique, cette action est irréversible.',
    onHide() {
      store.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => toggleVisiblity?.(),
        variant: 'secondary',
      },
    ],
  };
};
